// @flow
/* eslint-disable react/display-name */
import React from "react";
import { List, Datagrid, ShowButton, DateField, SelectField, EditButton } from "react-admin";
import { RECOMMENDED_PLAYLISTS_NAMES } from '../consts'

/* we use perPage={10000} because we don't want to use pagination here. */
export default (props /*: Object */) => (
  <List title="Все рекомендованные плейлисты" {...props} perPage={10000} bulkActionButtons={null}>
    <Datagrid>
      <SelectField
        label="Тип"
        source="type"
        choices={RECOMMENDED_PLAYLISTS_NAMES}
      />
      <DateField showTime label="Дата создания" source="createdAt" />
      <DateField showTime label="Дата редактирования" source="updatedAt" />
      <ShowButton />
      <EditButton />
    </Datagrid>
  </List>
);

/*
  type: GoodType;
  name: string;
  price: number;
  createdAt?: Date;
  updatedAt?: Date;
  _id: Types.ObjectId;
  code?: string;
*/
